<template lang="pug">
  div
    page_header(title="Partner", subhead="Edit")
      router-link.btn.btn-primary.ml-3.d-none.d-sm-inline-block(:to='{name: "partner.index", params:{id:id}}')
        i.feather-arrow-left
        | Back

    .row
      .col-sm-12
        form_card(
          :errors="errors"
          v-model="form"
          :schema="schema"
          :loading="sending"
          @submit="submit"
        )


</template>

<script>
import page_header from '@/components/pageHeader'
import form_card from '@/components/forms/card-form'
import schema from './form'

import { mapActions, mapState } from 'vuex'

export default {
  name: 'Partner',
  props: ['id'],
  components: {
    page_header,
    form_card
  },
  data(){
    return {
      form: {
        name: '',
        date: '',
        entity_type: '',
        entity_id: '',
        brief: '',
        status: ''
      },
      blank: {
        name: '',
        position: '',
        company: '',
        image: '',
        brief: '',
        status: ''
      },
      schema: schema,
      industries: [],
      associations: []
    }
  },
  computed: {
    ...mapState('api', ['errors', 'sending'])
  },
  methods: {
    resetForm(){
      this.form = JSON.parse(JSON.stringify(this.blank));
    },
    submit(){
      var vm = this;
      this.call({_vm:this, endpoint: 'admin/partner', method: 'POST', data: this.form}).then(()=>{
        vm.resetForm();
      });
    },
    ...mapActions('api', ['call'])
  },
}
</script>